import React from 'react';

import {SweetCreatableReactSelect} from 'app/components/general/SweetReactSelect';
import {
  InlineStepNumberedTitle,
  InlineStepNumberedTitleStructure,
} from 'app/procedures/components/InlineStepNumberAndTitle';
import {getArtificialEndingStep, hasFinalEnding} from 'app/procedures/utils';
import {gt} from 'app/utils/i18n';

import type {AnyStepType} from 'sweet-types';

type Props = {
  skipStepId?: string;
  steps: Array<AnyStepType>;
  onChange: (id: string | void) => void;
  value: AnyStepType | null | void;
  onCreateStep: (id: string) => void;
  menuIsOpen?: boolean;
};

export const StepSelect = ({
  steps,
  skipStepId,
  onChange,
  value,
  onCreateStep,
  menuIsOpen,
}: Props) => {
  const getStepTitle = (step: AnyStepType) => {
    if (step.id != null) {
      return (
        <InlineStepNumberedTitle
          type={step.type}
          n={step.n}
          title={step.title}
          fixedWidth={true}
        />
      );
    } else {
      return (
        <InlineStepNumberedTitleStructure
          icon={<i className="fa fa-plus-circle" />}
          title={gt('Create "%s" step', step.title)}
          fixedWidth={true}
        />
      );
    }
  };

  const getOptions = () => {
    const filteredSteps =
      skipStepId != null ? steps.filter(({id}) => id !== skipStepId) : steps;
    let options: Array<AnyStepType> = [...filteredSteps];

    if (!hasFinalEnding(steps)) {
      options.push(getArtificialEndingStep(steps.length + 1));
    }

    return options;
  };

  const handleChange = (step: AnyStepType | null | void) => {
    onChange(step == null ? undefined : step.id);
  };
  const searchStep = (
    {
      data: {title, n},
    }: {
      data: AnyStepType;
    },
    query: string
  ) => {
    if (query === '' || title == null) {
      return true;
    }

    return (
      title.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
      n.toString() === query
    );
  };
  const commonProps = {
    getNewOptionData: (title: string) => ({
      title,
    }),
    onCreateOption: onCreateStep,
    formatCreateLabel: (query) => query,
    onChange: handleChange,
    options: getOptions(),
    isClearable: true,
    getOptionValue: (step) => step.id,
    getOptionLabel: getStepTitle,
    placeholder: gt('Create or select a step as target...'),
    filterOption: searchStep,
    value,
    menuIsOpen,
  };
  return (
    <SweetCreatableReactSelect
      {...commonProps}
      getNewOptionData={(title: string) => ({
        title,
      })}
      onCreateOption={onCreateStep}
      formatCreateLabel={(query) => query}
    />
  );
};
